import { render, staticRenderFns } from "./QueryMsgHistory.vue?vue&type=template&id=392e1a1e&scoped=true&"
import script from "./QueryMsgHistory.vue?vue&type=script&lang=js&"
export * from "./QueryMsgHistory.vue?vue&type=script&lang=js&"
import style0 from "./QueryMsgHistory.vue?vue&type=style&index=0&id=392e1a1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392e1a1e",
  null
  
)

export default component.exports